module.exports = __webpack_public_path__ + "static/media/background.6bce9a0e.png";